import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { deleteLink } from 'redux/links/actions';

import FavoriteLinkAction
  from 'components/dashboard/links-content/common-link-item/FavoriteLinkAction';
import FastlinkAction
  from 'components/dashboard/links-content/common-link-item/FastlinkAction';
import CommonLinkActionButton
  from 'components/common/link-elements/CommonLinkActionButton';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './CommonLinkActions.css';

function CommonLinkActions(props) {
  const {
    linkItem,
    deleteLink,
    linkExpanded,
    setLinkExpanded,
    videoOptionsOpened,
    setVideoOptionsOpened,
    twitterOptionsOpened,
    setTwitterOptionsOpened,
    tiktokOptionsOpened,
    setTiktokOptionsOpened,
    pinterestOptionsOpened,
    setPinterestOptionsOpened,
    mobile,
  } = props;
  const { t } = useTranslation();

  const onLinkTypeButtonClick = (linkTypeOptionsOpened, setLinkTypeOptionsOpened) => {
    if (!mobile) {
      if (!linkExpanded && !linkTypeOptionsOpened) {
        setLinkExpanded(true);
        setLinkTypeOptionsOpened(true);
      }
      if (linkExpanded && !linkTypeOptionsOpened) {
        setLinkTypeOptionsOpened(true);
      }
      if (linkExpanded && linkTypeOptionsOpened) {
        setLinkExpanded(false);
        setLinkTypeOptionsOpened(false);
      }
      if (!linkExpanded && linkTypeOptionsOpened) {
        setLinkTypeOptionsOpened(false);
      }
    } else {
      setLinkTypeOptionsOpened(!linkTypeOptionsOpened);
    }
  };

  const linkTypeActionButtons = [
    {
      type: 'video',
      buttonText: t('Video'),
      onClick: () => onLinkTypeButtonClick(videoOptionsOpened, setVideoOptionsOpened),
      active: videoOptionsOpened,
    },
    {
      type: 'twitter',
      buttonText: t('Twitter'),
      onClick: () => onLinkTypeButtonClick(twitterOptionsOpened, setTwitterOptionsOpened),
      active: twitterOptionsOpened,
    },
    {
      type: 'tiktok',
      buttonText: t('TikTok'),
      onClick: () => onLinkTypeButtonClick(tiktokOptionsOpened, setTiktokOptionsOpened),
      active: tiktokOptionsOpened,
    },
    {
      type: 'pinterest',
      buttonText: t('Pinterest'),
      onClick: () => onLinkTypeButtonClick(pinterestOptionsOpened, setPinterestOptionsOpened),
      active: pinterestOptionsOpened,
    },
  ];

  const linkTypeActionButton = linkTypeActionButtons.filter(button => button.type === linkItem.link_type)[0];

  const renderLinkTypeActionButton = () => {
    if (!linkTypeActionButton) return null;

    return (
      <div className={linkTypeActionButton.type}>
        <CommonLinkActionButton
          type={linkTypeActionButton.type}
          buttonText={linkTypeActionButton.buttonText}
          onClick={linkTypeActionButton.onClick}
          active={linkTypeActionButton.active}
        />
      </div>
    );
  };

  return (
    <div className="common-link-actions__component">
      {renderLinkTypeActionButton()}

      <div className="effects">
        <FavoriteLinkAction
          linkId={linkItem.id}
          priorityClass={linkItem.priority_class}
        />
      </div>

      {!linkItem.is_header &&
        <div className="fast-link">
          <FastlinkAction
            linkId={linkItem.id}
            isFastlink={linkItem.is_fastlink}
          />
        </div>
      }

      <div className="delete">
        <CommonLinkDeleteButton
          linkItem={linkItem}
          deleteFunction={deleteLink}
        />
      </div>
    </div>
  );
}

CommonLinkActions.propTypes = {
  deleteLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  setLinkExpanded: PropTypes.func.isRequired,
  setVideoOptionsOpened: PropTypes.func.isRequired,
  setTwitterOptionsOpened: PropTypes.func.isRequired,
  setTiktokOptionsOpened: PropTypes.func.isRequired,
  setPinterestOptionsOpened: PropTypes.func.isRequired,
  linkExpanded: PropTypes.bool.isRequired,
  videoOptionsOpened: PropTypes.bool.isRequired,
  twitterOptionsOpened: PropTypes.bool.isRequired,
  tiktokOptionsOpened: PropTypes.bool.isRequired,
  pinterestOptionsOpened: PropTypes.bool.isRequired,
  mobile: PropTypes.bool,
};

CommonLinkActions.defaultProps = {
  mobile: null,
};

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    deleteLink,
  },
)(CommonLinkActions);
